<template>

    <div class="signup-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Reset Password</h2>
                        <form class="form" v-on:submit.prevent="signupFormSubmit">
                            <div class="input-field form-input">
                                <label for="old-password">Old Password</label>
                                <input type="password" placeholder="*******" v-model="oldPassword" id="old-password">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-password">New Password</label>
                                <input type="password" placeholder="*******" v-model="password" id="your-password">
                            </div>
                            <div class="input-field form-input">
                                <label for="confirm-password">Confirm New Password</label>
                                <input type="password" placeholder="*******" v-model="confirmPassword" id="confirm-password">
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SAVE</button>
                                <span v-if="FormSubmited">SAVE...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import router from '../router'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'ResetPassword',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        mounted () {},
        data() {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                nameFlag: false,
                emailFlag: false,
                FormSubmited: false,
                email: '',
                name: '',
                userData: userdata,
                status: '',
                oldPassword: '',
                password: '',
                confirmPassword: '',
                profileId: '',
                artistId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            yourName: function (msg) {
                if (!msg) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
            },
            yourEmail: function (msg) {
                if (!msg) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
            },
            signupFormSubmit: function (event) {
                if(this.password == this.confirmPassword){
                    this.FormSubmited = true
                    try {
                        axios.post('/resetPassword', {
                            email: this.userData.user.email,
                            password: this.password,
                            oldPassword: this.oldPassword
                        },{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.FormSubmited = false
                            var textMessage = 'Password Updated!'
                            var textMessageFlag = 'success'
                            if(!res.data.error){
                                textMessage = 'Old password is wrong'
                                textMessageFlag = 'error'
                            }
                            Vue.$toast.open(
                                {
                                    message: textMessage,
                                    type: textMessageFlag,
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                        }).catch(err => {
                            this.FormSubmited = false
                            console.log(err)
                        })
                    } catch (e) {
                        this.FormSubmited = false
                        console.log(e)
                    }
                } else {
                    Vue.$toast.open(
                        {
                            message: 'New Password mis-smatch',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue